/*
 * Model class Form
 */
export default class MonitorForms {
	constructor($http, $customer, $content, $mobile, $home_address_order, $member_id) {
		this.member_id = $member_id;
		this.http = $http;
		this.customer = $customer;
		this.content = $content;
		this.home_address_order = $home_address_order;
		this.data_content = this.content['form-label-msg'];
		this.popover_script = "<script>$('[data-toggle=\"popover\"]').popover({ trigger: \"hover\", container: '.monitorFormIsAbout' });</script>";
		this.preset = ($mobile == true) ? '/#/data-monitoring/' : '/user/dashboard/';
	}

	home_address_ordered(fields = undefined) {
	    var addr1       = '',
            addr2       = '',
            addr3       = '',
            postcode    = '',
            city        = '';

	    if (fields !== undefined) {
            addr1       = fields.addr1;
            addr2       = fields.addr2;
            addr3       = fields.addr3;
            postcode    = fields.postcode;
            city        = fields.city;
        }

		var address_fields = {
            'addr1'			:  	`<div class="form-group col-md-6">
									<label>${this.content['data-entry-form-address-house']}</label>
									<input type="text" class="form-control" data-input-type="numeric" label="true" name="addr1" placeholder="" value="${addr1}" />
								</div>`,
            'addr2' 		:   `<div class="form-group col-md-6">
									<label>${this.content['data-entry-form-street-name']}</label>
									<input type="text" class="form-control" label="true" name="addr2" placeholder="" value="${addr2}" />
								</div>`,
            'addr3'			: 	`<div class="form-group col-md-6">
									<label>${this.content['data-entry-form-additional']}</label>
									<input type="text" class="form-control" label="true" name="addr3" placeholder="" value="${addr3}" />
								</div>`,
			'postcode'		:  	`<div class="form-group col-md-6">
									<label>${this.content['data-entry-form-postcode']}</label>
									<input type="text" class="form-control" name="postcode" label="true" placeholder="" value="${postcode}" />
								</div>`,
			'city'			:  	`<div class="form-group col-md-6">
									<label>${this.content['data-entry-form-city']}</label>
									<input type="text" class="form-control" name="city" label="true" placeholder="" value="${city}" />
								</div>`
		};

		var address_order_result = {};

		for (var i in this.home_address_order) {
            address_order_result[this.home_address_order[i]] = address_fields[this.home_address_order[i]];
		}

		return address_order_result;
	}

	personal_details(fields = {}) {
		var details = {
				first_name	: "",
				last_name 	: "",
				alias 		: "",
				dob 		: "",
				sd_id 		: undefined,
				p_id 		: undefined
			},
			addEdit = 'add';

		for (var i in fields) {
			for (var key in fields[i]) {
				if (key == 'first_name' || key == 'last_name' || key == 'alias' || key == 'dob' || key == 'sd_id' || key == 'p_id') {
					details[key] = fields[i][key];
				}
			}
		}

		if (details.sd_id !== undefined) {
			addEdit = 'edit';
		}

		return `<div class="group ${addEdit}">
					<div class="form-group col-md-6">
						<label>${this.content['data-entry-form-first-name']}</label>
                        <input type="text" class="form-control" model="first_name" name="first_name" value="${this.customer.first_name}" readonly>
					</div>
					<div class="form-group col-md-6">
						<label>${this.content['data-entry-form-last-name']}</label>
						<input type="text" class="form-control" model="last_name" name="last_name" value="${this.customer.last_name}" readonly>
					</div>
					<div class="form-group col-md-6">
						<label>${this.content['data-entry-form-alias']}</label>
						<input type="text" class="form-control" model="alias" name="alias" value="${this.customer.alias}" readonly>
					</div>
					<div class="form-group ${details.sd_id !== undefined ? 'col-md-5' : 'col-md-6' }">
						<label>${this.content['data-entry-form-dob']}</label>
						<input type="hidden" name="_label" value="${this.content['data-entry-form-dob']}" />
						<input type="text" class="form-control" data-input-type="numeric" model="dob" label="true"  name="dob" alias-key-press="aliasKeyPressEvent" placeholder="${this.content['placeholder-dob-format']}" value="${details.dob}" />
												
						<input type="hidden" name="sd_id" value="${details.sd_id}" />
						<i data-toggle="popover" data-content="Date of Birth entered is incorrect" data-placement="left" class="fa fa-exclamation-circle" aria-hidden="true"></i>
						<i class="fa fa-check-circle" aria-hidden="true"></i>
						<script>$('[data-toggle="popover"]').popover({ trigger: "hover" });</script>
						
						<svg data-ng-if="${details.sd_id !== undefined}" data-ng-click="delete_monitor_info(${details.sd_id}, ${details.p_id}, 'dob', $event, modal_monitor_form.id)" class="flag-icon dob-delete"><use xlink:href="#delete-2" /></svg>
					</div>
			</div>`;
	}

	credit_cards(fields = []) {
		var group = "";

		if (fields.length > 0) {
			group = `<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ${this.content['data-monitoring-page-prefix-edit-credit']}</h4></div>`;
		}

		for (var i in fields) {
			group += `<div class="col-md-12 block">
						<div id="accordion-${i}" role="tablist" aria-multiselectable="true">
							<div class="card wow fadeInUp">
								<svg data-ng-click="delete_monitor_info(${fields[i].sd_id}, [${fields[i].p_id}], 'cc', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>

								<a data-toggle="collapse" data-parent="#accordion-${i}" class="collapsed" href="${this.preset}#credit_card-${i}">
									${fields[i].label}
									<span class="faq-arrow flaticon-down-arrow-1"></span>
								</a>
							</div>

							<div id="credit_card-${i}" class="collapse" role="tabpanel">
								<div class="group edit">
									<div class="col-md-12">
										<div class="col-md-6">
											<label>${this.content['data-entry-form-label']}</label>
											<div class="form-group">
												<input type="text" class="form-control" name="_label" value="${fields[i].label}">
											</div>
										</div>										
										<div class="form-group col-md-6">
											<label>${this.content['data-entry-form-credit-card']}</label>
											<input type="text" class="form-control" data-input-type="numeric" label="true" name="credit_card" value="${fields[i].credit_card}" />
										</div>
										<input type="hidden" name="sd_id" value="${fields[i].sd_id}" />
									</div>
								</div>
							</div>
						</div>
					</div>`;
		}

		return `<div class="group add">
					<div class="col-md-12">
						<div class="col-md-6">
							<label>${this.content['data-entry-form-label']}</label>
							<div class="form-group">
								<input type="text" class="form-control" name="_label">
								<i data-toggle="popover" data-content="${this.data_content}" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>
								${this.popover_script}
							</div>
						</div>
						<div class="form-group col-md-6">
							<label>${this.content['data-entry-form-credit-card']}</label>
							<input type="text" class="form-control" data-input-type="numeric" label="true" name="credit_card">
						</div>
					</div>
				</div>${group}`;
	}

	drivers_licenses(fields = []) {
		var group = "";

		if (fields.length > 0) {
			group = `<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ${this.content['data-monitoring-page-prefix-edit-driver']}</h4></div>`;
		}

		for (var i in fields) {
			group += `<div class="col-md-12 block">
						<div id="accordion-${i}" role="tablist" aria-multiselectable="true">
							<div class="card wow fadeInUp">
								<svg data-ng-click="delete_monitor_info(${fields[i].sd_id}, ${fields[i].p_id}, 'driving_license', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>

								<a data-toggle="collapse" data-parent="#accordion-${i}" class="collapsed" href="${this.preset}#license-${i}">
									${fields[i].label}
									<span class="faq-arrow flaticon-down-arrow-1"></span>
								</a>
							</div>

							<div id="license-${i}" class="collapse" role="tabpanel">
								<div class="group edit">
									<div class="col-md-12">
										<div class="col-md-6">
											<label>${this.content['data-entry-form-label']}</label>
											<div class="form-group">
												<input type="text" class="form-control" name="_label" value="${fields[i].label}">
											</div>
										</div>
										<div class="form-group col-md-6">
											<label>${this.content['data-entry-form-driver-license']}</label>
											<input type="text" class="form-control" label="true" name="driving_license" placeholder="" value="${fields[i].driving_license}" />
										</div>
										<input type="hidden" name="sd_id" value="${fields[i].sd_id}" />
										<input type="hidden" name="p_id" value="${fields[i].p_id}" />
									</div>
								</div>
							</div>
						</div>
					</div>`;
		}

		return `<div class="group add">
					<div class="col-md-12">
						<div class="col-md-6">
							<label>${this.content['data-entry-form-label']}</label>
							<div class="form-group">
								<i data-toggle="popover" data-content="${this.data_content}" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>
								<input type="text" class="form-control" name="_label" placeholder="">
								${this.popover_script}
							</div>
						</div>
						<div class="form-group col-md-6">
							<label>${this.content['data-entry-form-driver-license']}</label>
							<input type="text" class="form-control" label="true" name="driving_license" placeholder="">
						</div>
					</div>
				</div>${group}`;
	}

	home_address(fields = []) {
		var group = "";

		if (fields.length > 0) {
			group = `<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ${this.content['data-monitoring-page-prefix-edit-address']}</h4></div>`;
		}

		for (var i in fields) {
			group += `<div class="col-md-12 block">
						<div id="accordion-${i}" role="tablist" aria-multiselectable="true">
							<div class="card wow fadeInUp">
								<svg data-ng-click="delete_monitor_info(${fields[i].sd_id}, ${fields[i].p_id}, 'address', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>

								<a data-toggle="collapse" data-parent="#accordion-${i}" class="collapsed" href="${this.preset}#license-${i}">
									${fields[i].label}
									<span class="faq-arrow flaticon-down-arrow-1"></span>
								</a>
							</div>
							<div id="license-${i}" class="collapse" role="tabpanel">
								<div class="group edit">
									<div class="col-md-12">
										<div class="col-md-6">
											<label>${this.content['data-entry-form-label']}</label>
											<div class="form-group">
												<input type="text" class="form-control" name="_label" value="${fields[i].label}">
											</div>
										</div>`;

            var editAddress = this.home_address_ordered(fields[i]);

            for (let i in editAddress) {
                group += editAddress[i];
            }

            group += `<input type="hidden" name="sd_id" value="${fields[i].sd_id}" />
					  <input type="hidden" name="p_id" value="${fields[i].p_id}" />
									</div>
								</div>
							</div>
						</div>
					</div>`;
		}

		var add = `<div class="group add">
					<div class="col-md-12">
						<div class="col-md-6">
							<label>${this.content['data-entry-form-label']}</label>
							<div class="form-group">
								<input type="text" class="form-control" name="_label" placeholder="">
								<i data-toggle="popover" data-content="${this.data_content}" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>
								${this.popover_script}
							</div>
						</div>`;

		var addNewAddress = this.home_address_ordered();

		for (let i in addNewAddress) {
		    add += addNewAddress[i];
        }

        add += `</div>
				</div>${group}`;

		return add;
	}

	bank_accounts(fields = []) {
		var group = "";

		if (fields.length > 0) {
			group = `<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ${this.content['data-monitoring-page-prefix-edit-bank']}</h4></div>`;
		}

		for (var i in fields) {
			group += `<div class="col-md-12 block">
						<div id="accordion-${i}" role="tablist" aria-multiselectable="true">
							<div class="card wow fadeInUp">
								<svg data-ng-click="delete_monitor_info(${fields[i].sd_id}, ${fields[i].p_id}, 'bank', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>

								<a data-toggle="collapse" data-parent="#accordion-${i}" class="collapsed" href="${this.preset}#license-${i}">
									${fields[i].label}
									<span class="faq-arrow flaticon-down-arrow-1"></span>
								</a>
							</div>

							<div id="license-${i}" class="collapse" role="tabpanel">
								<div class="group edit">
									<div class="col-md-12">
										<div class="col-md-6">
											<label>${this.content['data-entry-form-label']}</label>
											<div class="form-group">
												<input type="text" class="form-control" name="_label" value="${fields[i].label}">
											</div>
										</div>
										<div class="form-group col-md-6">
											<label>${this.content['data-entry-form-bank-account']}</label>
											<input type="text" class="form-control" label="true" name="bank_account" placeholder="" value="${fields[i].bank_account}" />
										</div>
										<div class="form-group bank_code col-md-6">
											<label>${this.content['data-entry-form-bank-sort-code']}</label>
											<input type="text" class="form-control" label="true" name="bank_code" placeholder="" value="${fields[i].bank_code}" />
										</div>
										<input type="hidden" name="sd_id" value="${fields[i].sd_id}" />
										<input type="hidden" name="p_id" value="${fields[i].p_id}" />
									</div>
								</div>
							</div>
						</div>
					</div>`;
		}

		return `<div class="group add">
					<div class="col-md-12"">
						<div class="col-md-6">
							<label>${this.content['data-entry-form-label']}</label>
							<div class="form-group">
								<input type="text" class="form-control" name="_label" placeholder="">
								<i data-toggle="popover" data-content="${this.data_content}" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>
								${this.popover_script}
							</div>
						</div>
						<div class="form-group col-md-6">
							<label>${this.content['data-entry-form-bank-account']}</label>
							<input type="text" class="form-control" label="true" name="bank_account" placeholder="" />
						</div>
						<div class="form-group bank_code col-md-6">
							<label>${this.content['data-entry-form-bank-sort-code']}</label>
							<input type="text" class="form-control" label="true" name="bank_code" placeholder="" />
						</div>
					</div>
				</div>${group}`;
	}

	cpf_number(fields = []) {
		var sd_id = '',
            p_id = '';

        for (var i in fields) {
        	sd_id = fields[i].sd_id;
        	p_id = fields[i].p_id;
        }

        return `<div class="group add">
					<input type="hidden" name="sd_id" value="${sd_id}" />
					<input type="hidden" name="p_id" value="${p_id}" />
					<input type="hidden" name="_label" value="CPF Number" />
					<input type="hidden" name="passport" value="${this.member_id}" />
					<input type="hidden" name="cpf_checkbox" data-ng-value="cpf_checkbox == true ? 'ON' : 'OFF'" />
					
					<div class="col-md-12"">
						<div class="form-group col-md-6 cpf">
							<label>${this.member_id}</label>
						</div>
						
						<div class="form-group col-md-3 pull-right">							
							<label data-ng-bind="cpf_checkbox ? '${this.content['data-monitoring-page-cpf-number-activated']}' : '${this.content['data-monitoring-page-cpf-number-deactivated']}'"></label>
						</div>
					</div>
				</div>`;
	}

	passport(fields = []) {
		var group = "";

		if (fields.length > 0) {
			group = `<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ${this.content['data-monitoring-page-prefix-edit-passport']}</h4></div>`;
		}

		for (var i in fields) {
			group += `<div class="col-md-12 block">
						<div id="accordion-${i}" role="tablist" aria-multiselectable="true">
							<div class="card wow fadeInUp">
								<svg data-ng-click="delete_monitor_info(${fields[i].sd_id}, ${fields[i].p_id}, 'passport', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>

								<a data-toggle="collapse" data-parent="#accordion-${i}" class="collapsed" href="${this.preset}#passport-${i}">
									${fields[i].label}
									<span class="faq-arrow flaticon-down-arrow-1"></span>
								</a>
							</div>

							<div id="passport-${i}" class="collapse" role="tabpanel">
								<div class="group edit">
									<div class="col-md-12">
										<div class="col-md-6">
											<label>${this.content['data-entry-form-label']}</label>
											<div class="form-group">
												<input type="text" class="form-control" name="_label" value="${fields[i].label}">
											</div>
										</div>
										<div class="form-group col-md-6">
											<label>${this.content['data-entry-form-passport-number']}</label>
											<input type="text" class="form-control" label="true" name="passport" placeholder="" value="${fields[i].passport}" />
										</div>
										<input type="hidden" name="sd_id" value="${fields[i].sd_id}" />
										<input type="hidden" name="p_id" value="${fields[i].p_id}" />
									</div>
								</div>
							</div>
						</div>
					</div>`;
		}

		return `<div class="group add">
					<div class="col-md-12"">
						<div class="col-md-6">
							<label>${this.content['data-entry-form-label']}</label>
							<div class="form-group">
								<input type="text" class="form-control" name="_label" placeholder="">
								<i data-toggle="popover" data-content="${this.data_content}" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>
								${this.popover_script}
							</div>
						</div>
						<div class="form-group col-md-6">
							<label>${this.content['data-entry-form-passport-number']}</label>
							<input type="text" class="form-control" label="true" name="passport" placeholder="" />
						</div>
					</div>
				</div>${group}`;
	}

	email_address(fields = []) {
		var group = "";

		if (fields.length > 0) {
			group = `<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ${this.content['data-monitoring-page-prefix-edit-email']}</h4></div>`;
		}

		for (var i in fields) {
			group += `<div class="col-md-12 block">
						<div id="accordion-${i}" role="tablist" aria-multiselectable="true">
							<div class="card wow fadeInUp">
								<svg data-ng-click="delete_monitor_info(${fields[i].sd_id}, [${fields[i].p_id}], 'email', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>

								<a data-toggle="collapse" data-parent="#accordion-${i}" class="collapsed" href="${this.preset}#e-mail-${i}">
									${fields[i].label}
									<span class="faq-arrow flaticon-down-arrow-1"></span>
								</a>
							</div>

							<div id="e-mail-${i}" class="collapse" role="tabpanel">
								<div class="group edit">
									<div class="col-md-12">
										<div class="col-md-6">
											<label>${this.content['data-entry-form-label']}</label>
											<div class="form-group">
												<input type="text" class="form-control" name="_label" value="${fields[i].label}">
												${this.popover_script}
											</div>
										</div>
										<div class="form-group col-md-6">
											<label>${this.content['data-entry-form-email-address']}</label>
											<input type="text" class="form-control" label="true" name="email" value="${fields[i].email}">
										</div>
										<input type="hidden" name="sd_id" value="${fields[i].sd_id}" />
										<input type="hidden" name="p_id" value="${fields[i].p_id}" />
									</div>
								</div>
							</div>
						</div>
					</div>`;
		}

		return `<div class="group add">
					<div class="col-md-12"">
						<div class="col-md-6">
							<label>${this.content['data-entry-form-label']}</label>
							<div class="form-group">
								<input type="text" class="form-control" name="_label" placeholder="">
								<i data-toggle="popover" data-content="${this.data_content}" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>
								${this.popover_script}
							</div>
						</div>
						<div class="form-group col-md-6">
							<label>${this.content['data-entry-form-email-address']}</label>
							<input type="text" class="form-control" label="true" name="email" placeholder="" />
						</div>
					</div>
				</div>${group}`;
	}

	phone_number(fields = []) {
		var group = "";

		if (fields.length > 0) {
			group = `<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ${this.content['data-monitoring-page-prefix-edit-landline']}</h4></div>`;
		}

		for (var i in fields) {
			group += `<div class="col-md-12 block">
						<div id="accordion-${i}" role="tablist" aria-multiselectable="true">
							<div class="card wow fadeInUp">
								<svg data-ng-click="delete_monitor_info(${fields[i].sd_id}, ${fields[i].p_id}, 'phone', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>

								<a data-toggle="collapse" data-parent="#accordion-${i}" class="collapsed" href="${this.preset}#phone-${i}">
									${fields[i].label}
									<span class="faq-arrow flaticon-down-arrow-1"></span>
								</a>
							</div>

							<div id="phone-${i}" class="collapse" role="tabpanel">
								<div class="group edit">
									<div class="col-md-12">
										<div class="col-md-6">
											<label>${this.content['data-entry-form-label']}</label>
											<div class="form-group">
												<input type="text" class="form-control" name="_label" value="${fields[i].label}">
											</div>
										</div>
										<div class="form-group col-md-6">
											<label>${this.content['data-entry-form-landline']}</label>
											<input type="text" class="form-control" data-input-type="numeric_phone" label="true" name="phone" value="${fields[i].phone}" />
										</div>
										<input type="hidden" name="sd_id" value="${fields[i].sd_id}" />
										<input type="hidden" name="p_id" value="${fields[i].p_id}" />
									</div>
								</div>
							</div>
						</div>
					</div>`;
		}

		return `<div class="group add">
					<div class="col-md-12"">
						<div class="col-md-6">
							<label>${this.content['data-entry-form-label']}</label>
							<div class="form-group">
								<input type="text" class="form-control" name="_label" />
								<i data-toggle="popover" data-content="${this.data_content}" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>
								${this.popover_script}
							</div>
						</div>
						<div class="form-group col-md-6">
							<label>${this.content['data-entry-form-landline']}</label>
							<input type="text" class="form-control" data-input-type="numeric_phone" label="true" name="phone" />
						</div>
					</div>
				</div>${group}`;
	}

	mobile_number(fields = []) {
		var group = "";

		if (fields.length > 0) {
			group = `<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ${this.content['data-monitoring-page-prefix-edit-mobile']}</h4></div>`;
		}

		for (var i in fields) {
			group += `<div class="col-md-12 block">
						<div id="accordion-${i}" role="tablist" aria-multiselectable="true">
							<div class="card wow fadeInUp">
								<svg data-ng-click="delete_monitor_info(${fields[i].sd_id}, ${fields[i].p_id}, 'mobile', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>

								<a data-toggle="collapse" data-parent="#accordion-${i}" class="collapsed" href="${this.preset}#mobile-${i}">
									${fields[i].label}
									<span class="faq-arrow flaticon-down-arrow-1"></span>
								</a>
							</div>

							<div id="mobile-${i}" class="collapse" role="tabpanel">
								<div class="group edit">
									<div class="col-md-12">
										<div class="col-md-6">
											<label>${this.content['data-entry-form-label']}</label>
											<div class="form-group">
												<input type="text" class="form-control" name="_label" value="${fields[i].label}">
											</div>
										</div>
										<div class="form-group col-md-6">
											<label>${this.content['data-entry-form-mobile-number']}</label>
											<input type="text" class="form-control" data-input-type="numeric_phone" label="true" name="mobile" value="${fields[i].mobile}" />
										</div>
										<input type="hidden" name="sd_id" value="${fields[i].sd_id}" />
										<input type="hidden" name="p_id" value="${fields[i].p_id}" />
									</div>
								</div>
							</div>
						</div>
					</div>`;
		}

		return `<div class="group add">
					<div class="col-md-12"">
						<div class="col-md-6">
							<label>${this.content['data-entry-form-label']}</label>
							<div class="form-group">
								<input type="text" class="form-control" name="_label" />
								<i data-toggle="popover" data-content="${this.data_content}" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>
								${this.popover_script}
							</div>
						</div>
						<div class="form-group col-md-6">
							<label>${this.content['data-entry-form-mobile-number']}</label>
							<input type="text" class="form-control" data-input-type="numeric_phone" label="true" name="mobile" />
						</div>
					</div>
				</div>${group}`;
	}

	national_insurance_number(fields = []) {
		var group = "";

		if (fields.length > 0) {
			group = `<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ${this.content['data-monitoring-page-prefix-edit-ni']}</h4></div>`;
		}

		for (var i in fields) {
			group += `<div class="col-md-12 block">
						<div id="accordion-${i}" role="tablist" aria-multiselectable="true">
							<div class="card wow fadeInUp">
								<svg data-ng-click="delete_monitor_info(${fields[i].sd_id}, ${fields[i].p_id}, 'ssn', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>

								<a data-toggle="collapse" data-parent="#accordion-${i}" class="collapsed" href="${this.preset}#ni-${i}">
									${fields[i].label}
									<span class="faq-arrow flaticon-down-arrow-1"></span>
								</a>
							</div>

							<div id="ni-${i}" class="collapse" role="tabpanel">
								<div class="group edit">
									<div class="col-md-12">
										<div class="col-md-6">
											<label>${this.content['data-entry-form-label']}</label>
											<div class="form-group">
												<input type="text" class="form-control" name="_label" value="${fields[i].label}">
											</div>
										</div>
										<div class="form-group col-md-6">
											<label>${this.content['data-entry-form-ssn']}</label>
											<input type="text" class="form-control" label="true" name="ssn" value="${fields[i].ssn}" />
										</div>
										<input type="hidden" name="sd_id" value="${fields[i].sd_id}" />
										<input type="hidden" name="p_id" value="${fields[i].p_id}" />
									</div>
								</div>
							</div>
						</div>
					</div>`;
		}

		return `<div class="group add">
					<div class="col-md-12"">
						<div class="col-md-6">
							<label>${this.content['data-entry-form-label']}</label>
							<div class="form-group">
								<input type="text" class="form-control" name="_label" placeholder="">
								<i data-toggle="popover" data-content="${this.data_content}" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>
								${this.popover_script}
							</div>
						</div>
						<div class="form-group col-md-6">
							<label>${this.content['data-entry-form-ssn']}</label>
							<input type="text" class="form-control" label="true" name="ssn" />
						</div>
					</div>
				</div>${group}`;
	}

    social_network(fields = []) {
        var group = "";

        if (fields.length > 0) {
            group = `<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ${this.content['data-monitoring-page-prefix-edit-social-network']}</h4></div>`;
        }

        for (var i in fields) {
            group += `<div class="col-md-12 block">
						<div id="accordion-${i}" role="tablist" aria-multiselectable="true">
							<div class="card wow fadeInUp">
								<svg data-ng-click="delete_monitor_info(${fields[i].sd_id}, ${fields[i].p_id}, 'social_network', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>

								<a data-toggle="collapse" data-parent="#accordion-${i}" class="collapsed" href="${this.preset}#social_network-${i}">
									${fields[i].label}
									<span class="faq-arrow flaticon-down-arrow-1"></span>
								</a>
							</div>

							<div id="social_network-${i}" class="collapse" role="tabpanel">
								<div class="group edit">
									<input type="hidden" name="no-monitoring" value="social_network">
									<div class="col-md-12">
										<div class="col-md-6">
											<label>${this.content['data-entry-form-social-network-name']}</label>
											<div class="form-group">
												<input type="text" class="form-control" name="_label" value="${fields[i].label}">
											</div>
										</div>
										<div class="form-group col-md-6">
											<label>${this.content['data-entry-form-social-network-login']}</label>
											<input type="text" class="form-control" label="true" name="social_network" placeholder="" value="${fields[i].email}" />
										</div>
										<input type="hidden" name="sd_id" value="${fields[i].sd_id}" />
										<input type="hidden" name="p_id" value="${fields[i].p_id}" />
									</div>
								</div>
							</div>
						</div>
					</div>`;
        }

        return `<div class="group add">
					<input type="hidden" name="no-monitoring" value="social_network">
					<div class="col-md-12"">
						<div class="col-md-6">
							<label>${this.content['data-entry-form-social-network-name']}</label>
							<div class="form-group">
								<input type="text" class="form-control" name="_label" placeholder="">
								<i data-toggle="popover" data-content="${this.data_content}" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>
								${this.popover_script}
							</div>
						</div>
						<div class="form-group col-md-6">
							<label>${this.content['data-entry-form-social-network-login']}</label>
							<input type="text" class="form-control" label="true" name="social_network" placeholder="" />
						</div>
					</div>
				</div>${group}`;
    }

    ebay(fields = []) {
        var group = "";

        if (fields.length > 0) {
            group = `<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ${this.content['data-monitoring-page-prefix-edit-driver']}</h4></div>`;
        }

        for (var i in fields) {
            group += `<div class="col-md-12 block">
						<div id="accordion-${i}" role="tablist" aria-multiselectable="true">
							<div class="card wow fadeInUp">
								<svg data-ng-click="delete_monitor_info(${fields[i].sd_id}, ${fields[i].p_id}, 'ebay', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>

								<a data-toggle="collapse" data-parent="#accordion-${i}" class="collapsed" href="${this.preset}#license-${i}">
									${fields[i].label}
									<span class="faq-arrow flaticon-down-arrow-1"></span>
								</a>
							</div>

							<div id="license-${i}" class="collapse" role="tabpanel">
								<div class="group edit">
									<div class="col-md-12">
										<div class="col-md-6">
											<label>${this.content['data-entry-form-label']}</label>
											<div class="form-group">
												<input type="text" class="form-control" name="_label" value="${fields[i].label}">
											</div>
										</div>
										<div class="form-group col-md-6">
											<label>${this.content['data-entry-form-ebay']}</label>
											<input type="text" class="form-control" label="true" name="ebay" placeholder="" value="${fields[i].ebay}" />
										</div>
										<input type="hidden" name="sd_id" value="${fields[i].sd_id}" />
										<input type="hidden" name="p_id" value="${fields[i].p_id}" />
									</div>
								</div>
							</div>
						</div>
					</div>`;
        }

        return `<div class="group add">
					<div class="col-md-12">
						<div class="col-md-6">
							<label>${this.content['data-entry-form-label']}</label>
							<div class="form-group">
								<i data-toggle="popover" data-content="${this.data_content}" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>
								<input type="text" class="form-control" name="_label" placeholder="">
								${this.popover_script}
							</div>
						</div>
						<div class="form-group col-md-6">
							<label>${this.content['data-entry-form-ebay']}</label>
							<input type="text" class="form-control" label="true" name="ebay" placeholder="">
						</div>
					</div>
				</div>${group}`;
    }

    paypal(fields = []) {
        var group = "";

        if (fields.length > 0) {
            group = `<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ${this.content['data-monitoring-page-prefix-edit-driver']}</h4></div>`;
        }

        for (var i in fields) {
            group += `<div class="col-md-12 block">
						<div id="accordion-${i}" role="tablist" aria-multiselectable="true">
							<div class="card wow fadeInUp">
								<svg data-ng-click="delete_monitor_info(${fields[i].sd_id}, ${fields[i].p_id}, 'paypal', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>

								<a data-toggle="collapse" data-parent="#accordion-${i}" class="collapsed" href="${this.preset}#license-${i}">
									${fields[i].label}
									<span class="faq-arrow flaticon-down-arrow-1"></span>
								</a>
							</div>

							<div id="license-${i}" class="collapse" role="tabpanel">
								<div class="group edit">
									<div class="col-md-12">
										<div class="col-md-6">
											<label>${this.content['data-entry-form-label']}</label>
											<div class="form-group">
												<input type="text" class="form-control" name="_label" value="${fields[i].label}">
											</div>
										</div>
										<div class="form-group col-md-6">
											<label>${this.content['data-entry-form-paypal']}</label>
											<input type="text" class="form-control" label="true" name="paypal" placeholder="" value="${fields[i].paypal}" />
										</div>
										<input type="hidden" name="sd_id" value="${fields[i].sd_id}" />
										<input type="hidden" name="p_id" value="${fields[i].p_id}" />
									</div>
								</div>
							</div>
						</div>
					</div>`;
        }

        return `<div class="group add">
					<div class="col-md-12">
						<div class="col-md-6">
							<label>${this.content['data-entry-form-label']}</label>
							<div class="form-group">
								<i data-toggle="popover" data-content="${this.data_content}" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>
								<input type="text" class="form-control" name="_label" placeholder="">
								${this.popover_script}
							</div>
						</div>
						<div class="form-group col-md-6">
							<label>${this.content['data-entry-form-paypal']}</label>
							<input type="text" class="form-control" label="true" name="paypal" placeholder="">
						</div>
					</div>
				</div>${group}`;
    }

	id_number(fields = []) {

	}
}
